import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SlidersHorizontal } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { formatFechaHora } from '@/lib/recuentos';
import { ajustesAPI } from './ajustes/ajustesApi';
import { BodegasTab } from './ajustes/BodegasTab';
import { LocalesTab } from './ajustes/LocalesTab';

const HistorialTab = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => { ajustesAPI.historial().then((r) => setRows(r.data)); }, []);
  if (!rows) return <p className="mt-4 text-slate-500">Cargando...</p>;
  return (
    <div className="bg-white rounded-xl border overflow-x-auto mt-4">
      <table className="w-full text-sm" data-testid="ajustes-historial-table">
        <thead className="bg-slate-50 text-slate-600"><tr>
          <th className="px-4 py-2 text-left">Fecha</th><th className="px-4 py-2 text-left">Usuario</th><th className="px-4 py-2 text-left">Qué</th>
          <th className="px-4 py-2 text-left">Cambio</th>
        </tr></thead>
        <tbody>
          {rows.length === 0 && <tr><td colSpan={4} className="px-4 py-6 text-center text-slate-400">Sin cambios registrados</td></tr>}
          {rows.map((r) => (
            <tr key={r.id} className="border-t">
              <td className="px-4 py-2 text-slate-600">{formatFechaHora(r.fecha)}</td>
              <td className="px-4 py-2">{r.user_name}</td>
              <td className="px-4 py-2"><span className="text-xs text-slate-400 uppercase mr-1">{r.entidad}</span>{r.entidad_nombre} · {r.campo}</td>
              <td className="px-4 py-2">{r.antes != null && <><span className="line-through text-red-600">{r.antes}</span> → </>}<b className="text-green-700">{r.despues}</b></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default function AdminAjustesPage() {
  const [params, setParams] = useSearchParams();
  const tab = params.get('tab') || 'bodegas';
  return (
    <div className="space-y-6" data-testid="admin-ajustes-page">
      <div>
        <h1 className="text-2xl font-bold text-slate-800 flex items-center gap-2"><SlidersHorizontal className="w-7 h-7 text-orange-500" /> Ajustes</h1>
        <p className="text-slate-500 mt-1 text-sm">Bodegas TUPU, locales y la bodega que abastece a cada uno</p>
      </div>
      <Tabs value={tab} onValueChange={(v) => setParams({ tab: v })}>
        <TabsList>
          <TabsTrigger value="bodegas" data-testid="ajustes-tab-bodegas">Bodegas</TabsTrigger>
          <TabsTrigger value="locales" data-testid="ajustes-tab-locales">Locales</TabsTrigger>
          <TabsTrigger value="historial" data-testid="ajustes-tab-historial">Historial de cambios</TabsTrigger>
        </TabsList>
        <TabsContent value="bodegas"><BodegasTab /></TabsContent>
        <TabsContent value="locales"><LocalesTab /></TabsContent>
        <TabsContent value="historial"><HistorialTab /></TabsContent>
      </Tabs>
    </div>
  );
}
